import React from 'react';
import { Popover } from 'grab-ui';
import PropTypes from 'prop-types';
import cx from 'classnames';
import I18n from 'i18n-js';
import formatCurrency from 'common/utils/format-currency';
import currencyFormats from 'constants/currency-constants';

import styles from '../shopify-orders/styles.less';

const fulfillmentDetails = fulfillmentOrder =>
  fulfillmentOrder && (
    <div className={cx(styles.detailsContent, styles.itemDetails)}>
      {fulfillmentOrder.lineItems && (
        <div className={styles.section}>
          <div className={styles.header}>
            {I18n.t('shopify.orders.fulfillmentDetails.itemDetails')}
          </div>
          <div className={styles.itemDetailsList}>
            {fulfillmentOrder.lineItems.map(lineItem => (
              <div key={lineItem.ID} className={styles.itemDetails}>
                <div className={styles.itemDetailsCol}>
                  {lineItem.quantity}x
                </div>
                <div className={cx(styles.itemDetailsCol, styles.itemName)}>
                  {lineItem.name}
                </div>
                <div className={styles.itemDetailsCol}>
                  {currencyFormats.find(f => f.code === lineItem.currency)
                    ? formatCurrency({
                        code: lineItem.currency,
                        amount: lineItem.subtotalPrice,
                      })
                    : `${lineItem.currency} ${lineItem.subtotalPrice}`}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {fulfillmentOrder.note && (
        <div className={styles.section}>
          <div className={styles.header}>
            {I18n.t('shopify.orders.fulfillmentDetails.customerNote')}
          </div>
          <div> {fulfillmentOrder.note} </div>
        </div>
      )}
    </div>
  );

const ShopifyDetailsPopover = ({
  children,
  fulfillmentOrder,
  onVisibleChange,
}) => (
  <Popover
    placement="bottom"
    content={fulfillmentDetails(fulfillmentOrder)}
    trigger="hover"
    overlayClassName={styles.detailsPopover}
    onVisibleChange={onVisibleChange}
  >
    {children}
  </Popover>
);

ShopifyDetailsPopover.propTypes = {
  fulfillmentOrder: PropTypes.shape({}).isRequired,
  children: PropTypes.elementType,
  onVisibleChange: PropTypes.func,
};

ShopifyDetailsPopover.defaultProps = {
  children: null,
  onVisibleChange: null,
};

export default ShopifyDetailsPopover;
